import { type ICSVExport } from '@principle-theorem/ng-shared';
import { LabJobIncomeTimestampField } from '@principle-theorem/principle-core/interfaces';
import { type IPractitionerLabFeeReportRecord } from '@principle-theorem/reporting';
import { DAY_MONTH_YEAR_FORMAT, toMoment } from '@principle-theorem/shared';

export interface IPractitionerLabFeesDrilldownCSV {
  date: string;
  patient: string;
  lab: string;
  type: string;
  cost: number;
}

const TIMESTAMP_FIELD_HEADER: Record<LabJobIncomeTimestampField, string> = {
  [LabJobIncomeTimestampField.SentAt]: 'Date Sent',
  [LabJobIncomeTimestampField.ReceivedAt]: 'Date Received',
  [LabJobIncomeTimestampField.IssuedAt]: 'Date Issued',
};

export class PractitionerLabFeesDrilldownToCSV
  implements
    ICSVExport<
      IPractitionerLabFeeReportRecord,
      IPractitionerLabFeesDrilldownCSV
    >
{
  defaultFileName = 'practitioner-lab-fees-drilldown';
  headers: string[];

  constructor(
    private _timestampField: LabJobIncomeTimestampField = LabJobIncomeTimestampField.IssuedAt
  ) {
    this.headers = [
      TIMESTAMP_FIELD_HEADER[this._timestampField],
      'Patient',
      'Lab',
      'Type',
      'Cost',
    ];
  }

  translate(
    records: IPractitionerLabFeeReportRecord[]
  ): IPractitionerLabFeesDrilldownCSV[] {
    return records.map((record) => {
      const timestamp = record.labJob[this._timestampField];
      return {
        date: timestamp
          ? toMoment(timestamp).format(DAY_MONTH_YEAR_FORMAT)
          : '',
        patient: record.labJob.patient.name,
        lab: record.labJob.lab.name,
        type: record.labJob.type.name,
        cost: record.summary.labFeesAmount,
      };
    });
  }
}
